/**
 * SocialLink Molecule Component
 * Social media icon link with hover effects
 */

import React from "react";
import { Link } from "@/components/atoms/Link";
import { Icon } from "@/components/atoms/Icon";
import { SocialLinkBlok } from "@/types";

export interface SocialLinkProps extends SocialLinkBlok {
  className?: string;
}

export const SocialLink: React.FC<SocialLinkProps> = ({
  platform,
  url,
  className = "",
}) => {
  return (
    <Link
      href={url}
      target="_blank"
      className={`
        flex items-center justify-center text-primary hover:text-primary
        transition-all duration-200
        ${className}
      `}
      aria-label={`Follow us on ${platform}`}
    >
      <Icon name={platform} size={24} />
    </Link>
  );
};

export default SocialLink;
